(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Infinate Scroll
//
// ------------------------------------

//posts-loop
(function($) {

	if (typeof window.InifiteScroll == 'undefined') window.InifiteScroll = {};

	InifiteScroll = {

		ready: false,

		button_text: null,

		// ------------------------------------
		// Init
		// ------------------------------------

	    init: function() {

	        if($('.posts-loop').length <= 0){ return; }

	        this.ready = true;

	        this.setup();

	    },

	    // ------------------------------------
	    // Setup
	    // ------------------------------------

	    setup: function(){
	    	console.log("SETUP");
	    	// Scroll Events
	    	$(document).on('scroll',function(e){
				if(InifiteScroll.ready == true){
					if(InifiteScroll.is_in_view('.posts-loop-pagination')){
						InifiteScroll.ready = false;
						InifiteScroll.load($('.pagination-next'));
					}
				}
			});

			// Button Click
			$('.pagination-next').on('click',function(e){

        		e.preventDefault();

                if(InifiteScroll.ready == true) { InifiteScroll.load($(this)); }

        	});

	    },

	    // ------------------------------------
	    // Load
	    // ------------------------------------

	    load:function(a){

	    	if(InifiteScroll.button_text == null){ InifiteScroll.button_text = a.html(); }

	    	a.html("Loading...");

        	var $posts = $("<div class=\"load-container\"></div>");

    		$posts.load( a.attr('href') + " .posts-loop-row", function(){

    			// Get Parts
    			var $cards = $posts.find('.card');
    			var $next  = $posts.find('.pagination-next');

    			// Animate In
    			var i = 0;
    			$cards.each(function(index){

    				var $card = $(this);
    				$card.addClass('animate-in');
    				$card.appendTo('.posts-loop');
    				setTimeout(function(){ $card.removeClass('animate-in'); }, 100 * i);
    				i++;

    			});

    			// Replace Pagination Link
    			if($next.length <= 0){
    				a.remove();
    			} else {
    				a.html(InifiteScroll.button_text);
    				a.attr('href',$next.attr('href'));
    			}

    			InifiteScroll.ready = true;

    		});

	    },

	    // ------------------------------------
	    // Is In View
	    // ------------------------------------

	    is_in_view: function(elem) {

        	var $elem = $(elem);
        	if($elem.length != 1){ return; }
		    var $window = $(window);

		    var docViewTop = $window.scrollTop();
		    var docViewBottom = docViewTop + $window.height();

		    var elemTop = $elem.offset().top;
		    var elemBottom = elemTop + $elem.height();

		    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

	}

	module.exports = InifiteScroll;

})(jQuery);
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/infinite-scroll.js","/modules")